var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137.358,
    height: 272.347,
    viewBox: "0 0 137.358 272.347",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6956",
    "data-name": "Group 6956",
    transform: "translate(-127.32 -1078.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "smartphone_1_",
    "data-name": "smartphone (1)",
    d: "M202.135,245.261a4,4,0,0,1-3.678,4.255h-46.7a4.3,4.3,0,0,1,0-8.511h46.7A4,4,0,0,1,202.135,245.261ZM243.983,23.5V248.857c0,12.952-9.927,23.49-22.124,23.49H128.749c-12.2,0-22.124-10.538-22.124-23.49V23.5c0-12.952,9.922-23.5,22.124-23.5h93.109C234.057,0,243.983,10.543,243.983,23.5Zm-7.356,0A14.9,14.9,0,0,0,221.859,8.511H199.987v9.3a4,4,0,0,1-3.678,4.255H151.862a4,4,0,0,1-3.678-4.255v-9.3H128.749A14.893,14.893,0,0,0,113.981,23.5V248.857a14.888,14.888,0,0,0,14.768,14.979h93.109a14.891,14.891,0,0,0,14.768-14.979Z",
    transform: "translate(20.695 1078.594)",
    fill: "#4cb3c4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "app-store_4_",
    "data-name": "app-store (4)",
    transform: "translate(151 1170.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16084",
    "data-name": "Path 16084",
    d: "M70.748,89h-52.5A18.273,18.273,0,0,1,0,70.748v-52.5A18.273,18.273,0,0,1,18.252,0h52.5A18.273,18.273,0,0,1,89,18.252v52.5A18.273,18.273,0,0,1,70.748,89Z",
    fill: "#00c3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16085",
    "data-name": "Path 16085",
    d: "M282.248,0H256V89h26.248A18.273,18.273,0,0,0,300.5,70.748v-52.5A18.273,18.273,0,0,0,282.248,0Z",
    transform: "translate(-211.5)",
    fill: "#00aaf0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6954",
    "data-name": "Group 6954",
    transform: "translate(14.862 18.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16086",
    "data-name": "Path 16086",
    d: "M119.111,366.826a4.348,4.348,0,0,1-5.936,1.591h0a4.351,4.351,0,0,1-1.591-5.936l.855-1.48h10.036Z",
    transform: "translate(-106.57 -316.501)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16087",
    "data-name": "Path 16087",
    d: "M89.846,146.029a4.346,4.346,0,0,1,0-8.691h8.549l11.725-20.309-3.178-5.5a4.351,4.351,0,0,1,1.591-5.936h0a4.351,4.351,0,0,1,5.936,1.591l.669,1.159.669-1.158a4.346,4.346,0,1,1,7.527,4.346l-14.9,25.813h9.4l5.018,8.691Z",
    transform: "translate(-85.5 -105.007)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6955",
    "data-name": "Group 6955",
    transform: "translate(44.5 18.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16088",
    "data-name": "Path 16088",
    d: "M290.831,219.689H287.3l2.862,4.957a4.346,4.346,0,1,1-7.527,4.345l-15.089-26.135,5.018-8.691L282.282,211h8.549a4.346,4.346,0,0,1,0,8.691Z",
    transform: "translate(-265.539 -178.667)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16089",
    "data-name": "Path 16089",
    d: "M256,291v8.691h7.711L258.693,291Z",
    transform: "translate(-256 -258.669)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16090",
    "data-name": "Path 16090",
    d: "M264.63,108.227a4.346,4.346,0,0,0-7.961-1.048L256,108.337h0V125.72l8.2-14.2A4.317,4.317,0,0,0,264.63,108.227Z",
    transform: "translate(-256 -105.006)",
    fill: "#f2f2f2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIos);
export default __webpack_public_path__ + "static/media/app-ios.916880a4.svg";
export { ForwardRef as ReactComponent };